import React, { useEffect, useState } from "react"
import { Col, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row } from "reactstrap"
import PageBody from "../../../components/PageBody"
import NumberFormat from "react-number-format"
import TextUtils from "../../../helpers/TextUtils"
import 'react-image-lightbox/style.css'
import IconCheckbox from '../../../assets/images/icon-checkbox.png'
import IconCheckboxActive from '../../../assets/images/icon-checkbox-active.png'


const ProductEditDetail = (props: any) => {
    const { data, dataActive, imgs, setData, type, onlyView, category, brand, origin , varriant, handleChangeVariant, handleChangeInput, validation, onValidation} = props
    const [productDetail, setProductDetail] = useState<any>(dataActive);

    const productDetailLockup:any = {}
    productDetailLockup[data?.sku] = productDetailLockup
    varriant?.map((item:any, index:any)=>{
        if(!productDetailLockup[item?.sku]) productDetailLockup[item?.sku] = {}
        productDetailLockup[item?.sku] = {
            index: index,
            indexParent: null,
        }
        item?.units?.map((itemUnit:any, indexUnit:number)=>{
            if(!productDetailLockup[itemUnit?.sku]) productDetailLockup[itemUnit?.sku] = {}
            productDetailLockup[itemUnit?.sku] = {
                index: indexUnit,
                indexParent: index,
            }
        })
    })

    useEffect(()=>{
        setProductDetail(dataActive)
    },[dataActive])

    const handleChangeDetail = (e:any)=>{
        const {name, value} = e.target
        setProductDetail({
            ...productDetail,
            [name]: value
        })
        const findIndex = productDetailLockup ? productDetailLockup[dataActive?.sku] : {}
        handleChangeVariant(findIndex?.index, name, value, findIndex?.indexParent)
        if(varriant?.length === 0){
            setData({
                ...data,
                [name]: value
            })
        }
    }

    console.log("productDetailLockup", productDetailLockup)

    return (
        <PageBody>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div className="nutri-title mb-3">Thông tin chi tiết phiên bản</div>
                {props?.handleActionModal &&
                <div className='select-menu-add' style={{border: 'none'}} onClick={() => props?.handleActionModal({type: 'unitModal'})}>
                    <i className="uil-plus mr-1"></i> Thêm / sửa  đơn vị quy đổi
                </div>
                }
            </div>
            <Row>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>SKU</Label>
                        <InputGroup>
                            {productDetail?.sku  || '---'}
                        </InputGroup>
                    </FormGroup>
                </Col>
                {varriant?.length === 0 &&
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>SKU ERP</Label>
                        <InputGroup>
                            <Input type="text" value={data?.erp_sku} onChange={(e: any) => handleChangeInput(e)} name="erp_sku" placeholder="Nhập SKU ERP..." />
                            <InputGroupAddon onClick={()=>{
                                props?.loadInfoProductErp(data?.erp_sku)
                            }} addonType="append" className='d-flex align-items-center' cssModule={{color: '#48a800'}}  style={{right: -15, top: 5, color: '#48a800', cursor: "pointer"}}>
                                <span style={{color: '#48a800'}}>Lấy thông tin</span>
                            </InputGroupAddon>
                            {/* 0102041111 */}
                        </InputGroup>
                    </FormGroup>
                </Col>}
                {/* <Col md={8} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Tên biến thể</Label>
                        <InputGroup>
                            {productDetail?.name  || '---'}
                        </InputGroup>
                    </FormGroup>
                </Col> */}
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Mã vạch</Label>
                        <InputGroup>
                            <Input disabled={props?.user?.store_id?.is_erp_stock} type="text" value={productDetail?.barcode} onChange={(e: any) => handleChangeDetail(e)} name="barcode" placeholder="Nhập barcode..." />
                        </InputGroup>
                    </FormGroup>
                </Col>
                {varriant?.length > 0 &&
                <Col md={4} xs={12}></Col>}
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Chiều dài / Chiều rộng / Chiều cao</Label>
                        <div style={{ display: 'flex', alignItems: 'center'}}>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeDetail({target:{ name: "longs" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'longs'} type={'text'} className="form-control" 
                                value={productDetail?.longs || ''}
                                placeholder={"dài..."} thousandSeparator={true} 
                            />
                            /<NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeDetail({target:{ name: "width" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'width'} type={'text'} className="form-control" 
                                value={productDetail?.width || ''}
                                placeholder={"rộng..."} thousandSeparator={true} 
                            />
                            /<NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeDetail({target:{ name: "height" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'height'} type={'text'} className="form-control" 
                                value={productDetail?.height || ''}
                                placeholder={"cao..."} thousandSeparator={true} 
                            />    
                        </div>
                        
                        <div className="unit">cm</div>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Khối lượng (g)</Label>
                        <InputGroup>
                            <Input type="text" value={productDetail?.weight || ''} onChange={(e: any) => handleChangeDetail(e)} name="weight" placeholder="Nhập trọng lượng..." />
                        </InputGroup>
                    </FormGroup>
                </Col>
                
            </Row>
            <div className="nutri-title mb-3">Giá bán</div>
            <Row>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Giá nhập</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeDetail({target:{ name: "price_import" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'price_import'} type={'text'} className="form-control" 
                                value={type === 'view' && !productDetail?.price_import ? '---': productDetail?.price_import}
                                placeholder={(type=='view' && !productDetail?.price_import) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label><span>*</span>Giá bán lẻ</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView || props?.user?.store_id?.is_erp_stock}
                                onChange={(e: any) => handleChangeDetail({target:{ name: "price" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'price'} type={'text'} className="form-control" 
                                value={type === 'view' && !productDetail?.price ? '---': productDetail?.price}
                                placeholder={(type=='view' && !productDetail?.price) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className='nutri-form'>
                        <Label>Bán buôn</Label>
                        <InputGroup>
                            <NumberFormat 
                                disabled={onlyView}
                                onChange={(e: any) => handleChangeDetail({target:{ name: "price_wholesale" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                name={'price_wholesale'} type={'text'} className="form-control" 
                                value={type === 'view' && !productDetail?.price_wholesale ? '---': productDetail?.price_wholesale}
                                placeholder={(type=='view' && !productDetail?.price_wholesale) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                            />
                        </InputGroup>
                    </FormGroup>
                </Col>
                <Col md={4} xs={12}>
                    <FormGroup className={type != 'view' ? 'nutri-form placeholder-right1' : 'nutri-form'}>
                        <div className="d-flex align-items-center">
                            <Row style={{width:'100%'}}>
                                <Col xl={12}>
                                    <div className="nutri-checkbox" onClick={() => type =='view' ? {} : handleChangeInput({target:{ name: "vat_enable" , value: data?.vat_enable ? false: true }})}>
                                        <div className="icon">
                                            {data?.vat_enable ?
                                            <img src={IconCheckboxActive} alt="icon" />:    
                                            <img src={IconCheckbox} alt="icon" />  
                                            }
                                        </div>
                                        <div className="label">Áp dụng thuế</div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {data?.vat_enable ?
                        <>
                            <Label>Giá trị thuế</Label>
                            <InputGroup className='nutri-form form-group'>
                                <NumberFormat 
                                    disabled={onlyView}
                                    onChange={(e: any) => handleChangeDetail({target:{ name: "vat" ,value: TextUtils.onlyNumber(e.target.value) }})}
                                    name={'vat'} type={'text'} className="form-control" 
                                    value={type === 'view' && !productDetail?.vat ? '---': productDetail?.vat}
                                    placeholder={(type=='view' && !productDetail?.vat) ? "---" : "Nhập giá trị..."} thousandSeparator={true} 
                                />
                            </InputGroup>
                            <div className="unit" style={{zIndex: 9}}>%</div>
                        </>:''}
                    </FormGroup>
                </Col>
            </Row>
            
        </PageBody>
    )
}

export default ProductEditDetail